<div class="flex flex-col w-full">
	<ui-section title="Lender Details">
		<div section-content class="space-y-6">
			<div class="flex flex-row items-center align-middle space-x-3">
				<app-checkbox
					type="clear"
					[ngModel]="_mortgage?.actingForMortgagee"
					(ngModelChange)="setActingForMortgagee($event)"
				></app-checkbox>
				<span class="text-sm font-normal">Acting for Mortgagee</span>
			</div>
			<ui-info-row
				infoLabel="Lender"
				[infoValue]="(_mortgage?.lenders | keyvalue)?.[0]?.value?.name"
			/>
			<ui-info-row infoLabel="Mortgagee">
				<span class="text-grey">{{
					(_mortgage?.lenders | keyvalue)?.[0]?.value?.mortgageeName
						| capitalize
				}}</span>
			</ui-info-row>
			<ui-info-row
				*ngIf="_mortgage?.originatingTransitNumber"
				infoLabel="Originating Transit Number"
				[infoValue]="_mortgage.originatingTransitNumber"
			/>
			<ng-container *ngIf="instruction$ | async as instruction">
				<ui-info-row
					infoLabel="Service Address"
					[infoValue]="mortgageeServiceAddress | address"
				/>
				<ui-info-row
					infoLabel="Name Insured (Title Insurance)"
					[infoValue]="instruction?.namedTitleInsurance"
				/>
				<ui-info-row
					infoLabel="Name Insured (Fire Insurance)"
					[infoValue]="instruction?.namedFireInsurance?.name"
				/>
				<ui-info-row
					infoLabel="Service Address (Fire Insurance)"
					[infoValue]="
						instruction?.namedFireInsurance?.serviceAddress | address
					"
				/>
				<ui-info-row
					infoLabel="Service Phone #"
					[infoValue]="instruction?.lender?.telephone"
				/>
			</ng-container>

			<ng-container
				*ngIf="showContactInfo && _mortgage.syncFlowType !== 'email'"
			>
				<ui-section type="sub-section" title="Lender Contact">
					<div section-content class="gap-4">
						<div class="p-2 rounded-md border w-full items-center">
							<ui-info-row
								infoLabel="Name"
								matTooltip="This is the lender contact name from your instructions"
								matTooltipPosition="right"
								class="p-2"
							>
								<app-input
									[ngModel]="_mortgage.lenderContactName"
									(debounce)="setLenderContactName($event)"
								></app-input>
							</ui-info-row>
							<ui-info-row
								infoLabel="Phone #"
								matTooltip="This is the lender contact phone from your instructions"
								class="p-2"
								matTooltipPosition="right"
							>
								<app-input
									[ngModel]="_mortgage.lenderContactPhoneNumber"
									(debounce)="setLenderContactPhoneNumber($event)"
								></app-input>
							</ui-info-row>
						</div>
					</div>
				</ui-section>
			</ng-container>
		</div>
	</ui-section>
</div>
